/**
 * モバイル向け，デフォルトテーマの半分のサイズ
 */
const HalfTypographySize = {
  xs: '0.375rem',
  sm: '0.4375rem',
  md: '0.5rem',
  lg: '0.5625rem',
  xl: '0.625rem',
  '2xl': '0.75rem',
  '3xl': '0.9375rem',
  '4xl': '1.125rem',
  '5xl': '1.5rem',
  '6xl': '1.875rem',
  '7xl': '2.25rem',
  '8xl': '3rem',
  '9xl': '4rem',
};

export default HalfTypographySize;
